import { CustomImagePreview } from '../customImagePreview';
import { Main } from './styles';
interface Props {
  imageUrl: string;
  altText: string;
  isMargin?: boolean;
  isImage?: boolean;
  type?: 'Figma' | 'Inbox' | 'PrintScreen' | 'Youtube' | 'ScreenRecording' | 'Image';
  ShowImageOptions?: boolean;
  ShowImageBorder?: boolean;
  progress?: number;
  isUploading?: boolean;
}

export const RenderImagePreview = (props: Props) => {
  const { imageUrl, altText, isMargin, isImage, type, ShowImageOptions, ShowImageBorder, progress, isUploading } =
    props || {};
  // Other variables
  return (
    <Main role='button' isMargin={isMargin} onClick={(e) => e.stopPropagation()} isImage={isImage}>
      <CustomImagePreview
        src={imageUrl}
        alt={altText}
        type={type}
        ShowImageOptions={ShowImageOptions}
        ShowImageBorder={ShowImageBorder}
        progress={progress}
        isUploading={isUploading}
      />
    </Main>
  );
};
